import React, { useEffect, useState } from 'react';

import EditorWidgetContent from './EditorWidgetContent/EditorWidgetContent';
import LiveSiteWidgetContent from './LiveSiteWidgetContent/LiveSiteWidgetContent';
import { ConsentPolicy } from '../../types';

const WidgetRoot = () => {
  const [isAdvertisingPolicy, setIsAdvertisingPolicy] =
    useState<boolean>(false);

  const viewMode =
    typeof window !== 'undefined' ? window.Wix.Utils.getViewMode() : '';
  const isEditorOrPreview = ['editor', 'preview'].includes(viewMode);

  useEffect(() => {
    const handleConsentPolicyChanged = (consentPolicy: ConsentPolicy) => {
      setIsAdvertisingPolicy(Boolean(consentPolicy.policy.advertising));
    };

    if (typeof window !== 'undefined') {
      const initialPolicy =
        window.Wix.Utils.getCurrentConsentPolicy()() as ConsentPolicy;
      handleConsentPolicyChanged(initialPolicy);
     const onConsentPolicyChanged =  window.Wix.Utils.getOnConsentPolicyChanged();
     onConsentPolicyChanged(handleConsentPolicyChanged)
    }
  }, []);

  if (!isAdvertisingPolicy) {
    return null;
  }

  return (
    <>
      {isEditorOrPreview ? <EditorWidgetContent /> : <LiveSiteWidgetContent />}
    </>
  );
};

export default WidgetRoot;
